import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class ModuleParamCBLModel {
  private moduleName = 'cbl';
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    company: {
      label: this.moduleParamConfigGlob.getLabel(this.moduleName, 'company', 'Company'),
      isRequired: this.moduleParamConfigGlob.isRequired(this.moduleName, 'company'),
      isVisible: this.moduleParamConfigGlob.isVisible(this.moduleName, 'company'),
    },
    branch: {
      label: this.moduleParamConfigGlob.getLabel(this.moduleName, 'branch', 'Branch'),
      isRequired: this.moduleParamConfigGlob.isRequired(this.moduleName, 'branch'),
      isVisible: this.moduleParamConfigGlob.isVisible(this.moduleName, 'branch'),
    },
    location: {
      label: this.moduleParamConfigGlob.getLabel(this.moduleName, 'location', 'Location'),
      isRequired: this.moduleParamConfigGlob.isRequired(this.moduleName, 'location'),
      isVisible: this.moduleParamConfigGlob.isVisible(this.moduleName, 'location'),
    },
    cblTitle: {
      label: this.moduleParamConfigGlob.getLabel(this.moduleName, 'cblTitle', 'Ownership Details'),
    },
  };

  partyCbl = {
    partyBranch: {
      label: this.moduleParamConfigGlob.getLabel(this.moduleName, 'partyBranch', 'Business Associate Branch'),
      isRequired: this.moduleParamConfigGlob.isRequired(this.moduleName, 'partyBranch'),
      isVisible: this.moduleParamConfigGlob.isVisible(this.moduleName, 'partyBranch'),
    },
  };
}
